import _ from 'lodash';
import globalStore from '$$globalStore';
import constants from '../../../helpers/constants';
import EstimationWorker from '../../../components/workers/EstimationWorker';

export default async (taskId, ganttId, resourceId, resourcesList) => {
  const task = globalStore.getters['tasksModel/getTaskByGanttId'](+ganttId, +taskId); // todo: fix performance
  const item = resourcesList.find(resource => resource.resource_id === resourceId);

  if (item) {
    _.set(item, 'selected', !item.selected);
    _.set(item, 'value', item.selected ? item.value : 0);
  }

  if (item && item.type === constants.RESOURCE_TIME_TYPE) {
    _.set(item, 'valuePerDay', item.selected ? item.valuePerDay : 0);
  }

  const tasksResourcesToEstimate = [];

  if (task.estimation) {
    const selectedResources = resourcesList.filter(resource => resource.selected && resource.type === constants.RESOURCE_TIME_TYPE);

    selectedResources.length && tasksResourcesToEstimate.push({
      task_id: +taskId,
      gantt_id: +ganttId,
      resources: selectedResources.map(resource => ({ resource_id: resource.resource_id, value: null, valuePerDay: null })),
    });
  } else if (item && item.selected && item.type === constants.RESOURCE_TIME_TYPE) {
    tasksResourcesToEstimate.push({
      task_id: +taskId,
      gantt_id: +ganttId,
      resources: [{ resource_id: item.resource_id, value: null, valuePerDay: null }],
    });
  }

  const estimationWorkerData = await EstimationWorker.calculate(tasksResourcesToEstimate, 'changeTasks', 'updateTasksResourceEstimations');

  return resourcesList.map(resource => {
    const resourceEstimation = _.get(estimationWorkerData.diff.resourceEstimations, [taskId, resource.resource_id]);

    if (resourceEstimation) {
      return { ...resource, value: +resourceEstimation.value, valuePerDay: +resourceEstimation.valuePerDay };
    }

    return resource;
  });
};
